import "./NoInternet.css";
export const NoInternet = () => {
  return (
    <div className="lost_connection">
      <img width={100} src={"/wifi_icon.png"} alt="wifi icon" />
      <p>There is no internet connection!</p>
    </div>
  );
};
